"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APENFTOrders = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var ordersApi_1 = require("./ordersApi");
var orders_1 = require("./orders");
var account_1 = require("./account");
var nft_1 = require("./nft");
var types_1 = require("../utils/types");
var helper_1 = require("../utils/helper");
var makeOrder_1 = require("../utils/makeOrder");
var APENFTOrders = /** @class */ (function (_super) {
    __extends(APENFTOrders, _super);
    function APENFTOrders(walletProvider, apiConfig, walletAccount) {
        var _this = this;
        var _a;
        _this = _super.call(this, apiConfig) || this;
        _this.accountAddress = '';
        _this.accountAddress = (walletAccount === null || walletAccount === void 0 ? void 0 : walletAccount.address) || ((_a = walletProvider.defaultAddress) === null || _a === void 0 ? void 0 : _a.base58) || '';
        _this.orders = new orders_1.Orders(walletProvider, apiConfig);
        _this.account = new account_1.Account(walletProvider, apiConfig);
        _this.assetFactory = new nft_1.AssetFactory(walletProvider, apiConfig);
        _this.walletProvider = walletProvider;
        return _this;
    }
    // 取消订单签名
    APENFTOrders.prototype.ordersCancelSign = function (hash) {
        return __awaiter(this, void 0, void 0, function () {
            var signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, helper_1.web3Sign)(this.account.web3, hash, this.accountAddress)];
                    case 1:
                        signature = _a.sent();
                        return [2 /*return*/, { hash: hash, signature: signature }];
                }
            });
        });
    };
    APENFTOrders.prototype.getAssetOrderVersion = function (assetData) {
        return __awaiter(this, void 0, void 0, function () {
            var orderAsset, orderVersion, newAsset, sharedAsset;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderAsset = {
                            contractAddress: assetData.tokenAddress,
                            tokenId: assetData.tokenId,
                            chain: this.chain,
                            chainId: this.walletChainId
                        };
                        return [4 /*yield*/, this.ordersVersion(orderAsset)];
                    case 1:
                        orderVersion = _a.sent();
                        if (!orderVersion.isTradable) {
                            throw "Error";
                        }
                        newAsset = __assign({}, assetData);
                        sharedAsset = this.orders.APENFTSharedAssetAddr;
                        if (orderVersion.orderVersion === 1 &&
                            orderAsset.contractAddress === sharedAsset &&
                            orderVersion.uri &&
                            !assetData.data) {
                            newAsset = __assign(__assign({}, assetData), { data: orderVersion.uri });
                        }
                        else {
                            if (assetData.schemaName === types_1.APENFTSchemaName.ERC1155 && orderVersion.orderVersion === 0) {
                                newAsset = __assign(__assign({}, assetData), { data: '' });
                            }
                        }
                        return [2 /*return*/, { orderVersion: orderVersion, newAsset: newAsset }];
                }
            });
        });
    };
    APENFTOrders.prototype.createSellOrder = function (_a) {
        var asset = _a.asset, _b = _a.quantity, quantity = _b === void 0 ? 1 : _b, _c = _a.paymentToken, paymentToken = _c === void 0 ? this.orders.TRX : _c, _d = _a.listingTime, listingTime = _d === void 0 ? 0 : _d, _e = _a.expirationTime, expirationTime = _e === void 0 ? 0 : _e, startAmount = _a.startAmount, endAmount = _a.endAmount, buyerAddress = _a.buyerAddress;
        return __awaiter(this, void 0, void 0, function () {
            var _f, orderVersion, newAsset, sellParams, sellData, order;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, this.getAssetOrderVersion(asset)];
                    case 1:
                        _f = _g.sent(), orderVersion = _f.orderVersion, newAsset = _f.newAsset;
                        sellParams = {
                            asset: newAsset,
                            quantity: quantity,
                            paymentTokenObj: paymentToken,
                            accountAddress: this.accountAddress,
                            startAmount: startAmount,
                            endAmount: endAmount,
                            listingTime: listingTime,
                            expirationTime: expirationTime,
                            buyerAddress: buyerAddress
                        };
                        console.log(sellParams);
                        return [4 /*yield*/, this.orders.createSellOrder(sellParams)];
                    case 2:
                        sellData = _g.sent();
                        if (!sellData)
                            return [2 /*return*/];
                        order = __assign(__assign({}, sellData), { version: orderVersion.orderVersion });
                        return [2 /*return*/, this.ordersPost({ order: order })];
                }
            });
        });
    };
    APENFTOrders.prototype.createAuctionOrder = function (_a) {
        var asset = _a.asset, quantity = _a.quantity, paymentToken = _a.paymentToken, expirationTime = _a.expirationTime, startAmount = _a.startAmount, englishAuctionReservePrice = _a.englishAuctionReservePrice;
        return __awaiter(this, void 0, void 0, function () {
            var _b, orderVersion, newAsset, sellParams, sellData, order;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getAssetOrderVersion(asset)];
                    case 1:
                        _b = _c.sent(), orderVersion = _b.orderVersion, newAsset = _b.newAsset;
                        sellParams = {
                            asset: newAsset,
                            quantity: quantity,
                            paymentTokenObj: paymentToken,
                            accountAddress: this.accountAddress,
                            startAmount: startAmount,
                            englishAuctionReservePrice: englishAuctionReservePrice,
                            expirationTime: expirationTime,
                            waitForHighestBid: true
                        };
                        return [4 /*yield*/, this.orders.createSellOrder(sellParams)];
                    case 2:
                        sellData = _c.sent();
                        if (!sellData)
                            return [2 /*return*/];
                        order = __assign(__assign({}, sellData), { version: orderVersion.orderVersion });
                        return [2 /*return*/, this.ordersPost({ order: order })];
                }
            });
        });
    };
    APENFTOrders.prototype.createBiddingOrder = function (_a) {
        var asset = _a.asset, quantity = _a.quantity, paymentToken = _a.paymentToken, startAmount = _a.startAmount, bestAsk = _a.bestAsk;
        return __awaiter(this, void 0, void 0, function () {
            var askOrder, sellOrder, _b, orderVersion, newAsset, biddingParams, buyData, order;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if ((bestAsk === null || bestAsk === void 0 ? void 0 : bestAsk.bestAskOrderType) === 0)
                            return [2 /*return*/];
                        askOrder = bestAsk ? JSON.parse(bestAsk === null || bestAsk === void 0 ? void 0 : bestAsk.bestAskOrderString) : false;
                        sellOrder = this.orders.orderFromJSON(askOrder);
                        return [4 /*yield*/, this.getAssetOrderVersion(asset)];
                    case 1:
                        _b = _c.sent(), orderVersion = _b.orderVersion, newAsset = _b.newAsset;
                        paymentToken = paymentToken || this.orders.WTRXToken;
                        biddingParams = {
                            asset: newAsset,
                            accountAddress: this.accountAddress,
                            startAmount: startAmount,
                            paymentTokenObj: paymentToken,
                            expirationTime: sellOrder === null || sellOrder === void 0 ? void 0 : sellOrder.expirationTime.toNumber(),
                            quantity: sellOrder === null || sellOrder === void 0 ? void 0 : sellOrder.quantity.toNumber(),
                            sellOrder: sellOrder
                        };
                        return [4 /*yield*/, this.orders.createBuyOrder(biddingParams)];
                    case 2:
                        buyData = _c.sent();
                        if (!buyData)
                            return [2 /*return*/];
                        order = __assign(__assign({}, buyData), { version: orderVersion.orderVersion });
                        return [2 /*return*/, this.ordersPost({ order: order })];
                }
            });
        });
    };
    APENFTOrders.prototype.createBuyOrder = function (_a) {
        var asset = _a.asset, quantity = _a.quantity, paymentToken = _a.paymentToken, expirationTime = _a.expirationTime, startAmount = _a.startAmount;
        return __awaiter(this, void 0, void 0, function () {
            var _b, orderVersion, newAsset, buyParams, buyData, order;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.getAssetOrderVersion(asset)];
                    case 1:
                        _b = _c.sent(), orderVersion = _b.orderVersion, newAsset = _b.newAsset;
                        paymentToken = paymentToken || this.orders.WTRXToken;
                        buyParams = {
                            asset: newAsset,
                            accountAddress: this.accountAddress,
                            startAmount: startAmount,
                            paymentTokenObj: paymentToken,
                            expirationTime: expirationTime,
                            quantity: quantity
                        };
                        return [4 /*yield*/, this.orders.createBuyOrder(buyParams)];
                    case 2:
                        buyData = _c.sent();
                        if (!buyData)
                            return [2 /*return*/];
                        order = __assign(__assign({}, buyData), { version: orderVersion.orderVersion });
                        return [2 /*return*/, this.ordersPost({ order: order })];
                }
            });
        });
    };
    APENFTOrders.prototype.createLowerPriceOrder = function (_a) {
        var _b, _c;
        var oldOrder = _a.oldOrder, parameter = _a.parameter, asset = _a.asset;
        return __awaiter(this, void 0, void 0, function () {
            var metadataAsset, assetData, _d, orderVersion, newAsset, sharedAsset, isEnglishAuction, feeRecipientAddr, feeParams, unsignedOrder, _e, dataToCall, replacementPattern, unHashOrder, signOrder, order;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        metadataAsset = oldOrder.metadata.asset;
                        assetData = {
                            tokenAddress: metadataAsset.address,
                            tokenId: metadataAsset.id,
                            schemaName: oldOrder.metadata.schema
                        };
                        return [4 /*yield*/, this.getAssetOrderVersion(assetData)];
                    case 1:
                        _d = _f.sent(), orderVersion = _d.orderVersion, newAsset = _d.newAsset;
                        sharedAsset = this.orders.APENFTSharedAssetAddr;
                        isEnglishAuction = oldOrder.englishAuctionReservePrice && new bignumber_js_1.default(oldOrder.englishAuctionReservePrice).gt(0);
                        feeRecipientAddr = ((_b = asset.collection) === null || _b === void 0 ? void 0 : _b.transferFeeAddress)
                            ? (_c = asset.collection) === null || _c === void 0 ? void 0 : _c.transferFeeAddress
                            : this.account.feeRecipientAddress;
                        feeParams = isEnglishAuction
                            ? {
                                takerRelayerFee: asset === null || asset === void 0 ? void 0 : asset.collection.elementSellerFeeBasisPoints
                            }
                            : {
                                feeRecipient: feeRecipientAddr,
                                makerRelayerFee: asset === null || asset === void 0 ? void 0 : asset.collection.elementSellerFeeBasisPoints
                            };
                        if (metadataAsset.address === sharedAsset && orderVersion.uri && orderVersion.orderVersion === 1) {
                            metadataAsset.data = newAsset.data;
                        }
                        unsignedOrder = __assign(__assign(__assign(__assign({}, oldOrder), parameter), feeParams), { salt: (0, makeOrder_1.generatePseudoRandomSalt)() });
                        _e = this.orders.computeOrderCallData(unsignedOrder, this.orders.networkName, this.accountAddress), dataToCall = _e.dataToCall, replacementPattern = _e.replacementPattern;
                        unHashOrder = __assign(__assign({}, unsignedOrder), { dataToCall: dataToCall, replacementPattern: replacementPattern, makerReferrerFee: (0, helper_1.makeBigNumber)(0) });
                        return [4 /*yield*/, this.orders.createSignedOrder({ unHashOrder: unHashOrder })];
                    case 2:
                        signOrder = _f.sent();
                        if (!signOrder)
                            return [2 /*return*/];
                        order = __assign(__assign({}, signOrder), { version: orderVersion.orderVersion });
                        return [2 /*return*/, this.ordersPost({ order: order })];
                }
            });
        });
    };
    APENFTOrders.prototype.acceptOrder = function (bestOrder) {
        return __awaiter(this, void 0, void 0, function () {
            var accountAddress, signedOrder, recipientAddress, _a, buy, sell, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        accountAddress = this.accountAddress;
                        signedOrder = this.orders.orderFromJSON(bestOrder);
                        recipientAddress = '';
                        if (bestOrder.side === types_1.OrderSide.Sell) {
                            recipientAddress = accountAddress;
                        }
                        if (bestOrder.side === types_1.OrderSide.Buy) {
                            recipientAddress = bestOrder.maker;
                        }
                        _a = this.orders.makeMatchingOrder({ signedOrder: signedOrder, accountAddress: accountAddress, recipientAddress: recipientAddress }), buy = _a.buy, sell = _a.sell;
                        return [4 /*yield*/, this.account.orderMatch({
                                buy: buy,
                                sell: sell
                            })];
                    case 1:
                        res = _b.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    return APENFTOrders;
}(ordersApi_1.OrdersAPI));
exports.APENFTOrders = APENFTOrders;
